<template>
  <div class="home">
    <div class="header">
      <div class="title_container">
        <div
          v-for="(item, index) in titles"
          :key="item"
          :class="[isCurrentRouteIndex === index ? 'currentTitle' : '']"
          @click="goTo(index)"
        >
          {{ item }}
        </div>
      </div>
      <img
        class="logo"
        src="../../public/settings/images/logo.png"
      >
      <div class="mid_title">
        <p class="title">
          電気通信事業届出番号
        </p>
        <p class="tel">
          A-01-17153
        </p>
      </div>

      <div class="contact">
        <img
          class="tel"
          width="100px"
          src="../../public/settings/images/tel.png"
        >
        <div>
          <p>運絡先:</p>
          <p>03-5916-3011</p>
        </div>
      </div>
    </div>
    <div class="main">
      <router-view />
    </div>
    <div class="footer">
      <div>会社紹介</div>
      <div>会社名：Agsivo株式会社</div>
      <div>本社住所：東京都板橋区東坂下１丁目20番5号ハイツなつ１０１号室</div>
      <div>海外支社の住所：中国江蘇省無錫丁村工業園7号</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      titles: ['ホーム', '商品サービス', '事業内容', 'お問い合わせ'],
    }
  },
  computed: {
    isCurrentRouteIndex() {
      let routeName = this.$route.name || ''
      let currentIndex = routeName.charAt(routeName.length - 1)
      console.log('currentIndex', currentIndex)
      return currentIndex - 1
    },
  },
  created() {
    console.log('route increated', this.$route)
  },
  methods: {
    goTo(index) {
      this.$router.push(`/page${index + 1}`)
    },
  },
}
</script>
<style lang="scss" scoped>
.currentTitle {
  color: rgb(250, 211, 91) !important;
}

p {
  height: 8px;
  line-height: 8px;
}

.home {
  // height: 100%;
}

.main {
  // height: calc(100vh - 250px);
  min-height: 500px;
  // border: 1px solid black;
}

.header {
  // background: #fff;
  background-image: url('../../public/settings/images/bg_header.jpg');
  border-radius: 20px;
  height: 110px;
  // border: 1px solid red;
  margin-bottom: 10px;
  position: relative;
  padding: 5px 40px;

  .contact {
    text-align: left;
    position: absolute;
    right: 60px;
    top: 0;
    font-weight: bold;
    display: flex;
    align-items: center;

    div {
      margin-left: 20px;
      // color: #fff;
    }
    // .tel {
    //   position: absolute;
    //   top: 0;
    //   right: 80px;
    // }
  }

  .mid_title {
    .title {
      font-size: 28px;
    }
    .tel {
      color: rgb(216, 150, 78);
      font-weight: bold;
      font-size: 24px;
    }
  }
  .title_container {
    position: absolute;
    bottom: 10px;
    // display: flex;
    // justify-content: space-between;
    // width: 500px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    border-radius: 25px;

    div {
      display: inline-block;
      text-align: center;
      cursor: pointer;
      height: 30px;
      padding: 1px 12px;
      border-radius: 15px;
      color: #fff;
      border: 1px solid rgb(250, 211, 91);
    }

    div:hover {
      color: #fff !important;
      background: rgb(250, 211, 91);
    }

    div + div {
      border-left: 1px solid #ebeef5;
      margin-left: 8px;
    }
  }

  .logo {
    position: absolute;
    left: 35px;
  }
}

.footer {
  line-height: 30px;
  margin-top: 10px;
  color: #909399;
}
</style>
